
import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const Billingwhy = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Animation trigger when component enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      backgroundColor: "#025261",   
      color: "white",
      flexWrap: "wrap",
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(40px)",
      transition: "all 1s ease-in-out",
      maxWidth: "1200px",  
      margin: "0 auto", 
      borderRadius:"10px", 
    },
    leftSide: {
      flex: 1,
      paddingRight: isMobile ? "0" : "2rem",
      paddingTop: isMobile ? "2rem" : "0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: isMobile ? "0" : "1rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "bold",
      color: "white",  // Adjusted text color
      letterSpacing: "0px",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "1rem 0",
      textAlign: "justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.5rem",
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      marginRight: "0.5rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1.2rem" : "1.5rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      width: isMobile ? "100%" : "70%", // Adjusted to 70% for better size
      maxWidth: "500px",  // Reduced max-width to 500px
      height: "auto",
      borderRadius: "8px",
    },
  };

  return (
    <div ref={sectionRef} style={styles.container}>
      {/* Right Side (Image) */}
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/billingg.png"
            alt="Industrial Automation Features"
            style={styles.image}
          />
        </div>
      </div>

      {/* Left Side (Text) */}
      <div style={styles.leftSide}>
        <h2 style={styles.header}>Billing System Management</h2>
        <p style={styles.paragraph}>
          Our Billing System Management platform streamlines financial
          operations, automates payment workflows, and ensures accurate
          invoicing and reporting. Designed for businesses of all sizes, it
          integrates seamlessly with your existing systems to provide real-time
          tracking and secure transaction handling.
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Automated invoice generation and
            delivery
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Flexible payment processing with
            multiple gateways
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Subscription and recurring
            billing management
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Tax calculation and compliance
            tools
          </li>
          <li style={styles.listItem}>
            <span style={styles.arrow}>➔</span> Real-time transaction monitoring
            and reporting
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Billingwhy;
